exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes startOverTimeShiftingAnimationIn {\n    0% {\n        transform: scale(0.5);\n    }\n\n    100% {\n        transform: scale(1)\n    }\n}\n\n@keyframes startOverTimeShiftingAnimationOut {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(0.5);\n        opacity: 1;\n    }\n}\n\n@keyframes startOverTimeShiftingLineAnimationOut {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.ftv-magneto--slider:focus-visible {\n    box-shadow: #568EE8 0 0 0 2px inset;\n    border-radius: 2px;\n}\n", ""]);

// exports
